import { useIntl } from 'react-intl';

import ContourBackdrop from '../../components/ContourBackdrop/ContourBackdrop';
import styles from './PrivacyPolicy.module.css';

const CONTACT_EMAIL = 'contact@finpath.am';

// The mockup's seven numbered sections: a heading followed by its bullets. The
// numbering lives in the translations, so a locale can punctuate it its own way.
const SECTIONS = [
	{
		title: 'PrivacyPolicyId5',
		items: ['PrivacyPolicyId6', 'PrivacyPolicyId7'],
	},
	{
		title: 'PrivacyPolicyId8',
		items: [
			'PrivacyPolicyId9',
			'PrivacyPolicyId10',
			'PrivacyPolicyId11',
			'PrivacyPolicyId12',
		],
	},
	{
		title: 'PrivacyPolicyId13',
		items: [
			'PrivacyPolicyId14',
			'PrivacyPolicyId15',
			'PrivacyPolicyId16',
			'PrivacyPolicyId17',
			'PrivacyPolicyId18',
		],
	},
	{
		title: 'PrivacyPolicyId19',
		items: ['PrivacyPolicyId20', 'PrivacyPolicyId21'],
	},
	{
		title: 'PrivacyPolicyId22',
		items: ['PrivacyPolicyId23', 'PrivacyPolicyId24', 'PrivacyPolicyId25'],
	},
	{
		title: 'PrivacyPolicyId26',
		items: [
			'PrivacyPolicyId27',
			'PrivacyPolicyId28',
			'PrivacyPolicyId29',
			'PrivacyPolicyId30',
			'PrivacyPolicyId31',
		],
		// The last bullet reads "You can contact us at <address> for requests."
		email: true,
		emailSuffix: 'PrivacyPolicyId32',
	},
	{ title: 'PrivacyPolicyId33', items: ['PrivacyPolicyId34'] },
];

const Privacy = () => {
	const intl = useIntl();

	return (
		<div className={styles.page}>
			<main className={styles.main}>
				<section className={styles.section}>
					<ContourBackdrop
						className={styles.contoursRight}
						rings={7}
						from={3.4}
					/>
					<ContourBackdrop
						className={styles.contoursLeft}
						rings={7}
						from={3.4}
					/>

					<div className={styles.container}>
						<div className={styles.header}>
							<h1 className={styles.title}>
								{intl.formatMessage({ id: 'PrivacyPolicyId2' })}
							</h1>
							<p className={styles.lead}>
								{intl.formatMessage({ id: 'PrivacyPolicyId1' })}
							</p>
						</div>

						<div className={styles.doc}>
							{SECTIONS.map(({ title, items, email, emailSuffix }) => (
								<section key={title} className={styles.block}>
									<h2 className={styles.blockTitle}>
										{intl.formatMessage({ id: title })}
									</h2>
									<ul className={styles.list}>
										{items.map((id, index) => (
											<li key={id}>
												{intl.formatMessage({ id })}
												{email && index === items.length - 1 && (
													<>
														{' '}
														<a
															className={styles.mail}
															href={`mailto:${CONTACT_EMAIL}`}
														>
															{CONTACT_EMAIL}
														</a>
														{emailSuffix &&
															` ${intl.formatMessage({ id: emailSuffix })}`}
													</>
												)}
											</li>
										))}
									</ul>
								</section>
							))}
						</div>
					</div>
				</section>
			</main>
		</div>
	);
};

export default Privacy;
